<app-menu-common url="sales"></app-menu-common>

<div class="quotations-page">

  <!-- ══════════════════════════════════════════════════════════════════════════
  SÉLECTEUR — une seule barre : les 9 filtres, les raccourcis de période, les 2 actions.
  Remplace les trois rangées centrées d'origine (~205 px) par ~66 px.
  Pas de compteur ici : il est porté par la barre au-dessus du tableau.
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="toolbar-card">

    <div class="filter-item">
      <label class="filter-label" title="Aller droit à une commande par son numéro : Tab l'affiche seule dans la liste, Entrée ouvre sa fiche, l'icône l'ouvre dans un nouvel onglet">Id commande</label>
      <!-- 100 px : 7 chiffres visibles, un de plus que les numéros actuels (118 px en montrait 9). -->
      <smart-input #orderIdNav width="100px" type="number" placeholder="N°" icon="link"
        iconClass="custom-icon-button primary" [iconHref]="orderIdHref" iconTarget="_blank"
        [(ngModel)]="orderIdText" (valueChange)="onOrderIdChange($event)"
        (blurred)="onOrderIdBlur($event)" (enterPressed)="onOrderIdValidate($event)" />
    </div>

    <div class="filter-item partner-filter">
      <label class="filter-label">Client</label>
      <app-search-partner [currentPartner]="customer" width="420px" [showSelectionInInput]="true"
      (partnerChange)="customerChange($event)"></app-search-partner>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-state">Statut</label>
      <select id="flt-state" class="custom-select state-select" [(ngModel)]="filter.state" (change)="onFilterChange()">
        <!-- filter.state vaut '-1' au chargement : sans cette option, le select s'affichait VIDE.
        Les libellés passent des valeurs d'enum (CANCELED, PREPARATION…) au français. -->
        <option value="-1">Tous les statuts</option>
        @for (su of SalesOrderState | keyvalue; track su) {
          <option [value]="su.key">{{ getLabel(su.key) }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-doctype">Type</label>
      <!-- « Location » = les dossiers de location (contrats F3), filtrés par le serveur sur doc_type. -->
      <select id="flt-doctype" class="custom-select type-select" [(ngModel)]="filter.doc_type" (change)="onDocTypeChange()">
        <option value="-1">Tous les types</option>
        @for (t of docTypes; track t) {
          <option [value]="t">{{ docTypeName(t) }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-store">Magasin&nbsp;/&nbsp;Ets.</label>
      <select id="flt-store" class="custom-select store-select" [(ngModel)]="filter.store" (change)="onFilterChange()">
        @for (store of stores ; track store) {
          <option [value]="store.id">{{store.name}}&nbsp;{{ (store.id??0) >0 ?
          store.id :'' }}</option>
        }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-user">Employés</label>
      <select id="flt-user" class="custom-select user-select" [(ngModel)]="filter.user" (change)="onFilterChange()">
        @for (user of users ; track user) {
          <option [value]="user.id">{{(( user.firstname ??'') + ' ' + (
          user.lastname?? '') ).trim() }}</option>
        }
      </select>
    </div>

    <div class="filter-item date-filter">
      <label class="filter-label">Du</label>
      <app-select-date [date]="filter.datstart"
      (dateChange)="dateChange($event,'datstart')"></app-select-date>
    </div>

    <div class="filter-item date-filter">
      <label class="filter-label">Au</label>
      <app-select-date [date]="filter.datend"
      (dateChange)="dateChange($event,'datend')"></app-select-date>
    </div>

    <div class="period-presets" role="group" aria-label="Raccourcis de période">
      @for (p of periods; track p.key) {
        <button type="button" class="period-btn" [class.active]="isPeriod(p.key)" [title]="p.title"
          (click)="setPeriod(p.key)">{{ p.label }}</button>
      }
    </div>

    <div class="filter-item">
      <label class="filter-label" for="flt-limit" title="Nombre de réponses">Nb&nbsp;rép.</label>
      <select id="flt-limit" class="custom-select limit-select" [(ngModel)]="filter.limit" (change)="onFilterChange()">
        @for (val of limitsValue ; track val) {
          <option [value]="val">{{ limitLabel(val) }}</option>
        }
      </select>
    </div>

    <!-- Seuls le choix d'un client et ce bouton lancent une recherche : un filtre modifié vide la liste, ce bouton la remplit. -->
    <div class="toolbar-actions">
      <button type="button" class="btn-inline btn-search" (click)="onSearch()">
        <mat-icon [class.spinning]="is_loading">refresh</mat-icon><span>Rechercher</span>
      </button>
      <button mat-flat-button class="error btn-inline" aria-label="Effacer"
        title="Vider les filtres, sans relancer de recherche" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
  CONTENU : liste 70 % / aperçu 30 %, en ENFANTS DIRECTS de .content-row
  (c'est ce couple de sélecteurs qui porte le ratio).
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="content-row">

    <div class="table-card">

      <!-- Barre de la carte : identité, compteur, et les deux totaux de la liste -->
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>list_alt</mat-icon>
          <span>{{ isRentalFilter ? 'Dossiers de location' : 'Liste des commandes' }}</span>
          <span class="badge-count">{{ orders.length }}</span>
        </div>

        <div class="kpi-inline">
          <div class="kpi-chip" matTooltip="Total TTC des commandes affichées dans la liste">
            <mat-icon class="kpi-icon">functions</mat-icon>
            <span class="kpi-label">Total affiché</span>
            <span class="kpi-value">{{ totalAmount | number:'1.2-2' }}&nbsp;€</span>
          </div>
          <div class="kpi-chip due" [class.zero]="totalRemainer === 0"
            matTooltip="Somme des restes dus des commandes affichées dans la liste">
            <mat-icon class="kpi-icon">account_balance_wallet</mat-icon>
            <span class="kpi-label">Reste dû affiché</span>
            <span class="kpi-value">{{ totalRemainer | number:'1.2-2' }}&nbsp;€</span>
          </div>
        </div>
      </div>

      <div class="table-orders">

        <!-- Entête collante — expression de tri strictement inchangée -->
        <div class="order-line entete">
          @for (col of displayedColumnsInfo; track col[0]) {
            <div [class]="'cell ' + col[0]+'-cell '  + col[2]"
              [matTooltip]="colSortHint(col[0])" matTooltipClass="tooltip-multiline"
              (click)="sortOrders((col[3] === undefined ? true : (col[3] === true ? false : true)), col[0])"
              style="cursor: pointer;">
              <span class="sort-arrow">{{col[3] === undefined ? '' : (col[3] === true ? '&#8593;' : '&#8595;')}}</span> {{ col[1] }}
            </div>
          }
        </div>

        @if (orders.length > 0) {
          <!-- Body -->
          @for (o of orders; track o.id; let isEven = $even) {
            <!-- Nouvel onglet (JP, 26/10) : la liste et ses filtres restent dans celui-ci. -->
            <a class="order-line unstyled-link" [ngClass]="getColor(o.state)"
              [class.even]="isEven" [class.row-selected]="o.id === selected_id"
              [class.is-canceled]="o.state === SalesOrderState.CANCELED"
              [routerLink]="['/sales/quotation', o.id]" target="_blank" (mousedown)="keepOrderIdFocus($event)"
              (mouseover)="onMouseOver(o)" (mouseleave)="onMouseOut()">
              @for (col of displayedColumnsInfo; track col[0]) {
                <div [class]="'cell '  + col[0]+'-cell ' + col[2]">
                  @if (col[0] === 'id') {
                    <span class="id-val">{{ o.id }}</span>
                    @if (o.data?.doc_ref; as docRef) {
                      <span class="docref-badge"
                        [class.badge-ticket]="docRef.startsWith('TK-')"
                        [class.badge-facture]="docRef.startsWith('FAC-')"
                        [class.badge-avoir]="docRef.startsWith('AV-')"
                        [matTooltip]="'Pièce fiscale scellée : ' + docRef">
                        {{ docRef }}
                      </span>
                    }
                    @if (getParentOrderId(o); as parentId) {
                      <span class="parent-ref"
                        [matTooltip]="parentTooltip(o, parentId)"
                        (click)="goToParentOrder($event, parentId)">
                        <span class="parent-arrow">↳</span>{{ parentId }}
                      </span>
                    }
                    @if (getAvoirOrderId(o); as avoirId) {
                      <span class="parent-ref"
                        matTooltip="Consulter l'avoir de cette pièce"
                        (click)="goToParentOrder($event, avoirId)">
                        <span class="parent-arrow">↰</span>{{ avoirId }}
                      </span>
                    }
                  } @else if (col[0] === 'datecre') {
                    {{ $safeNavigationMigration(o.dates?.created) | date:'dd/MM/yy HH:mm':'Local' }}
                  } @else if (col[0] === 'dateval') {
                    {{ (getLastDate(o)) | date:'dd/MM/yy HH:mm':'Local' }}
                  } @else if (col[0] === 'type') {
                    @if (o.doc_type) {
                      <span class="type-chip"
                        [class.chip-contract]="isRentalContract(o)"
                        [class.chip-recurring]="isRentalChild(o)"
                        [matTooltip]="docTypeTooltip(o)">
                        {{ docTypeLabel(o) }}
                      </span>
                    }
                  } @else if (col[0] === 'store') {
                    {{ o.lnk_station?.store }}
                  } @else if (col[0] === 'station') {
                    {{ o.station }}
                  } @else if (col[0] === 'user') {
                    {{ getUserShortName(o.id_user) }}
                  } @else if (col[0] === 'status') {
                    <span class="state-pill">{{ getLabel(o.state) }}</span>
                  } @else if (col[0] === 'customer') {
                    {{ o.lnk_customer?.name }}&nbsp;{{ o.lnk_customer?.firstname }}
                  } @else if (col[0] === 'amount_taxi') {
                    {{ o.amount_taxi | number:'1.2-2' }}
                  } @else if (col[0] === 'amount_remainer') {
                    @if (getRemainer(o) !== 0) { {{ getRemainer(o) | number:'1.2-2' }} }
                    }
                  </div>
                }
              </a>
            }
          } @else if (is_loading) {
            <div class="loading-orders" style="grid-column: 1 / -1;">
              <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
              <span>Chargement des commandes…</span>
            </div>
          } @else if (listed) {
            <!-- Seulement après une recherche : une liste vidée par un filtre modifié n'annonce rien. -->
            <div class="empty-orders" style="grid-column: 1 / -1;">
              <mat-icon class="empty-icon">receipt_long</mat-icon>
              <div class="empty-title">{{ isRentalFilter ? 'Aucun dossier de location' : 'Aucune commande' }}</div>
              @if (orderId && searchFailed) {
                <div class="empty-subtitle">Lecture du n°&nbsp;{{ orderId }} en échec&nbsp;: Tab ou Rechercher la relance.</div>
              } @else if (orderId) {
                <div class="empty-subtitle">Aucune pièce ne porte le n°&nbsp;{{ orderId }}.</div>
              } @else {
                <div class="empty-subtitle">Aucune pièce ne correspond aux filtres courants&nbsp;: élargissez la période, le magasin ou l'employé.</div>
              }
              <!-- mousedown neutralisé : le blur d'un id tapé remplacerait l'état vide, bouton compris, avant le click -->
              <button mat-stroked-button color="primary" class="action-btn" (mousedown)="$event.preventDefault()" (click)="onCancel()">
                <mat-icon>clear</mat-icon>
                Réinitialiser les filtres
              </button>
            </div>
          }
        </div>
      </div>

      <!-- Aperçu de la commande survolée -->
      <div class="rightcontainer">
        <app-quotationdetails [mouseover$]="mouseoverSubject.asObservable()" [mouseout$]="mouseoutSubject.asObservable()" (quotationShown)="onQuotationShown($event)"></app-quotationdetails>
      </div>

    </div>
  </div>
